import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterFieldValue, FilterNumberRangeValue } from '../covance-filter.models';
import { CovanceFilterBaseType } from './covance-filter-base-type';
import { isNil } from 'lodash';

@Injectable()
export class CovanceFilterNumberRangeType extends CovanceFilterBaseType {
    private readonly separator = 'To';
    private readonly numberPattern = '\\s*-?[0-9]+(\\.[0-9]*)?\\s*';
    private readonly numberRegExp = new RegExp(`^(${this.numberPattern})$`);
    private readonly minRegExp = new RegExp(`^(${this.numberPattern})${this.separator}`);
    private readonly maxRegExp = new RegExp(`${this.separator}(${this.numberPattern})$`);

    constructor(router: Router, route: ActivatedRoute) {
        super(router, route);
    }

    public serializeValue(filterValue: any): string {
        return filterValue
            ? `From ${filterValue.min || ' - '} To ${filterValue.max || ' - '}`
            : '';
    }

    public isMatch(fieldVal: FilterFieldValue, value: any) {
        const range = fieldVal.value as FilterNumberRangeValue;

        return this.isMatchByRange(range, value);
    }

    public isMatchByRange(range: FilterNumberRangeValue, value: any) {
        if (range.min == null && range.max == null) {
            return true;
        }

        if (!this.isNumber(value)) {
            return false;
        }

        const numberValue = +value;
        return (range.min == null || numberValue >= range.min) && (range.max == null || numberValue <= range.max);
    }

    public setValue(fieldVal: FilterFieldValue) {
        if (!fieldVal.value || !fieldVal.queryParamValue) {
            fieldVal.value = {
                min: null,
                max: null
            } as FilterNumberRangeValue;
        }

        const matchMin = this.minRegExp.exec(fieldVal.queryParamValue);
        if (matchMin) {
            fieldVal.value.min = +matchMin[1];
        }

        const matchMax = this.maxRegExp.exec(fieldVal.queryParamValue);
        if (matchMax) {
            fieldVal.value.max = +matchMax[1];
        }
    }

    public setQueryParamValue(fieldVal: FilterFieldValue) {
        const filterValue = fieldVal.value as FilterNumberRangeValue;
        fieldVal.queryParamValue = (this.isNumber(filterValue.min) || this.isNumber(filterValue.max)) ?
            `${(this.isNumber(filterValue.min) ? filterValue.min : '')}${this.separator}${(this.isNumber(filterValue.max) ? filterValue.max : '')}` : '';
    }

    public isNumber(value: any): boolean {
        return !!this.numberRegExp.exec(value);
    }
}